var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDowndownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25586 7.32422L0.304688 2.39844C0.0761719 2.14453 0.0761719 1.76367 0.304688 1.53516L0.888672 0.951172C1.11719 0.722656 1.49805 0.722656 1.75195 0.951172L5.6875 4.86133L9.59766 0.951172C9.85156 0.722656 10.2324 0.722656 10.4609 0.951172L11.0449 1.53516C11.2734 1.76367 11.2734 2.14453 11.0449 2.39844L6.09375 7.32422C5.86523 7.55273 5.48438 7.55273 5.25586 7.32422Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDowndownArrow);
export default __webpack_public_path__ + "static/media/chevron-downdown-arrow.d147efe20e683a725fbbadbcac661b6e.svg";
export { ForwardRef as ReactComponent };